export default "__VITE_ASSET__BPV7s3Ai__"